export function getImageDimensions(fileSrc: string): Promise<{ width: number; height: number; }> {
	return new Promise(function (resolved, rejected) {
		const image = new Image()
		image.onload = function () {
			resolved({width: image.naturalWidth, height: image.naturalHeight})
		};
		image.src = fileSrc
	})
}
